// extracted by mini-css-extract-plugin
export default {"form":"XKheurXvdus1qZSJuSdQ__form___"};